import request from '@/http/axios'

// 校验媒体工具访问权限
export function checkMediaToolAccess() {
  return request({
    url: `/v1/media-tool/check-access`,
    method: 'get',
  })
}
